// src/components/ai/AiAttributionBadge.js
import React from 'react';

/**
 * Small attribution badge rendered below AI result content.
 * Communicates provenance and confidence to the coach.
 *
 * Props:
 *   basedOn     — string[] — e.g. ['reviews', 'lessons']
 *   confidence  — 'high' | 'medium' | 'low'
 */
function AiAttributionBadge({ basedOn = [], confidence = 'low' }) {
  const basedOnText = basedOn.length > 0 ? basedOn.join(', ') : 'limited data';

  const confidenceColour = {
    high: 'text-emerald-600',
    medium: 'text-amber-600',
    low: 'text-slate-400',
  }[confidence] || 'text-slate-400';

  return (
    <p className="mt-2 text-xs text-slate-400">
      AI suggestion · Based on:{' '}
      <span className="text-slate-500">{basedOnText}</span>
      {' '}·{' '}
      <span className={confidenceColour}>
        {confidence.charAt(0).toUpperCase() + confidence.slice(1)} confidence
      </span>
    </p>
  );
}

export default AiAttributionBadge;
